var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeadset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 43.866L75.269 44C75.4667 44 75.6644 43.9234 75.7962 43.7702C76.1916 43.3106 76.9 42.1043 76.9 39.3085C76.9 36.9149 76.1916 35.8043 75.7962 35.3638C75.6644 35.2106 75.4668 35.134 75.2855 35.134L54.5 35",
    fill: "#343333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 43.866L75.269 44C75.4667 44 75.6644 43.9234 75.7962 43.7702C76.1916 43.3106 76.9 42.1043 76.9 39.3085C76.9 36.9149 76.1916 35.8043 75.7962 35.3638C75.6644 35.2106 75.4668 35.134 75.2855 35.134L54.5 35L55.5 39L54.5 43.866Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.369 35H4.5C4.3023 35 4.10459 35.0778 3.97279 35.2333C3.5774 35.6998 2.86901 36.9244 2.86901 39.7624C2.86901 42.1922 3.5774 43.3197 3.97279 43.7667C4.10459 43.9222 4.30234 44 4.48356 44L25.769 44",
    fill: "#343333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.369 35H4.5C4.3023 35 4.10459 35.0778 3.97279 35.2333C3.5774 35.6998 2.86901 36.9244 2.86901 39.7624C2.86901 42.1922 3.5774 43.3197 3.97279 43.7667C4.10459 43.9222 4.30234 44 4.48356 44L25.769 44L25 39.5L25.369 35Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.248 41.7261C54.0083 41.7261 53 40.7263 53 39.4969C53 38.2676 54.0083 37.2677 55.248 37.2677C56.4877 37.2677 57.496 38.2676 57.496 39.4969C57.496 40.7263 56.4877 41.7261 55.248 41.7261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.248 41.7261C23.0083 41.7261 22 40.7263 22 39.4969C22 38.2676 23.0083 37.2677 24.248 37.2677C25.4877 37.2677 26.496 38.2676 26.496 39.4969C26.496 40.7263 25.4877 41.7261 24.248 41.7261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7356 39.1619C24.7356 47.5493 31.6075 54.3633 40.0418 54.3901V54.4066H40.0918C48.5656 54.4066 55.448 47.5822 55.448 39.1783C55.448 30.7743 48.549 23.95 40.0918 23.95C31.6348 23.95 24.7356 30.7579 24.7356 39.1619ZM25.6456 39.1783C25.6456 31.2729 32.1189 24.8532 40.0918 24.8532C48.0648 24.8532 54.5381 31.2729 54.5381 39.1783C54.5381 47.0837 48.0648 53.5034 40.0918 53.5034C32.1189 53.5034 25.6456 47.0837 25.6456 39.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.248 41.7261C59.0083 41.7261 58 40.7263 58 39.4969C58 38.2676 59.0083 37.2677 60.248 37.2677C61.4877 37.2677 62.496 38.2676 62.496 39.4969C62.496 40.7263 61.4877 41.7261 60.248 41.7261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.248 41.7261C64.0083 41.7261 63 40.7263 63 39.4969C63 38.2676 64.0083 37.2677 65.248 37.2677C66.4877 37.2677 67.496 38.2676 67.496 39.4969C67.496 40.7263 66.4877 41.7261 65.248 41.7261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.248 41.7261C69.0083 41.7261 68 40.7263 68 39.4969C68 38.2676 69.0083 37.2677 70.248 37.2677C71.4877 37.2677 72.496 38.2676 72.496 39.4969C72.496 40.7263 71.4877 41.7261 70.248 41.7261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.248 41.7098C18.0083 41.7098 17 40.7099 17 39.4806C17 38.2512 18.0083 37.2513 19.248 37.2513C20.4877 37.2513 21.496 38.2512 21.496 39.4806C21.496 40.7099 20.4877 41.7098 19.248 41.7098Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.248 41.7098C13.0083 41.7098 12 40.7099 12 39.4806C12 38.2512 13.0083 37.2513 14.248 37.2513C15.4877 37.2513 16.496 38.2512 16.496 39.4806C16.496 40.7099 15.4877 41.7098 14.248 41.7098Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24799 41.7098C8.00829 41.7098 7 40.7099 7 39.4806C7 38.2512 8.00829 37.2513 9.24799 37.2513C10.4877 37.2513 11.496 38.2512 11.496 39.4806C11.496 40.7099 10.4877 41.7098 9.24799 41.7098Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6612 41.0049C75.529 41.4803 75.3472 41.7425 75.248 41.7425C74.0083 41.7425 73 40.7427 73 39.5133C73 38.284 74.0083 37.2841 75.248 37.2841C75.3472 37.2841 75.529 37.5464 75.6612 38.0217C75.7769 38.3823 75.8596 38.8741 75.8596 39.5133C75.8596 40.1526 75.7769 40.6443 75.6612 41.0049Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19839 38.0217C4.33063 37.5464 4.51245 37.2841 4.61163 37.2841C5.85133 37.2841 6.85962 38.284 6.85962 39.5133C6.85962 40.7427 5.85133 41.7426 4.61163 41.7426C4.51245 41.7426 4.33063 41.4803 4.19839 41.0049C4.08269 40.6443 4.00005 40.1526 4.00005 39.5133C4.00005 38.8741 4.08269 38.3823 4.19839 38.0217Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3401 28.9993H29.8438V49.3245H50.3401V28.9993Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0888 24.7953L25.5957 39.1674L40.0888 53.5394L54.582 39.1674L40.0888 24.7953Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeadset);
export default __webpack_public_path__ + "static/media/Beadset.4c13b570e94f8cb9cc7b8c08fe604781.svg";
export { ForwardRef as ReactComponent };